module.exports = __webpack_public_path__ + "img/right2.0c70b214.png";